import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close--sharp",
  "use": "icon-close--sharp-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-close--sharp\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m13.948 0-5.98 5.976L1.992 0 0 1.992l5.978 5.975L0 13.946l1.992 1.992 5.976-5.976L13.887 16 16 13.886 9.962 7.97l5.978-5.977L13.948 0Z\" fill=\"#001233\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol